import { getCopiedLabels, getCopiedName } from "common/functions/labels";
import { hasRolePermissionTo } from "common/functions/roles";
import { Culture } from "common/culture/supported-cultures";
import { Context } from "common/types/context";
import { GoFn } from "common/types/url";
import { Report } from "common/types/reports";
import { exportCsv, exportPdf } from "x/reports/export-utils";
import { ActionsGroup, ReportAction } from "./type";

export const prepareReportForCopy = (
  report: Report,
  culture: Culture,
): Report => ({
  ...report,
  id: undefined,
  name: getCopiedName(report.name),
  label: report.label ? getCopiedName(report.label) : undefined,
  labels: getCopiedLabels(report.labels, culture),
});

export const getReportActions =
  (context: Context, report: Report, goTo: GoFn) => (): ActionsGroup[] => {
    const commonReportAction: ReportAction[] = [
      {
        name: "exportToCsv",
        label: _("Export to CSV"),
        permission: "Read",
        fn: exportCsv(context.apiCall, report),
      },
      {
        name: "exportToPdf",
        label: _("Export to PDF"),
        permission: "Read",
        fn: exportPdf(context.apiCall, report),
      },
      {
        name: "copyAdd",
        label: _("Copy/Add"),
        permission: "Create",
        fn: () =>
          goTo(`/${context.site.name}/Reports/new?sourceId=${report.id}`),
      },
    ];

    return [
      [
        "common",
        [
          ...commonReportAction.filter(({ permission }) =>
            hasRolePermissionTo(context.role, "Reports", permission),
          ),
        ],
      ],
    ];
  };
